import { httpClient } from '@/core/api/httpClient';
import { API_V1 } from '@/core/api/endpoints';
import type { CreateCalendarEventPayload, UpdateCalendarEventPayload } from '../types';
import type { RawInternalCalendarEvent } from '../adapters/external-calendar-event.adapter';

/**
 * CRUD for the caller's own "quick marker" events (milestone / time-entry),
 * `source: 'internal'` — see `backend-requirement-calendar-event-crud.md`.
 * Reads still go through the unified `GET /calendar/events`
 * (`external-calendar-events.service.ts`); only mutations live here.
 */
export const internalCalendarEventsService = {
  createEvent: async (payload: CreateCalendarEventPayload): Promise<RawInternalCalendarEvent> => {
    const { data } = await httpClient.post<CreateCalendarEventPayload, RawInternalCalendarEvent>(
      `${API_V1}/calendar/events`,
      payload,
    );
    return data;
  },

  updateEvent: async (eventId: string, payload: UpdateCalendarEventPayload): Promise<void> => {
    await httpClient.patch(`${API_V1}/calendar/events/${eventId}`, payload);
  },

  deleteEvent: async (eventId: string): Promise<void> => {
    await httpClient.delete(`${API_V1}/calendar/events/${eventId}`);
  },
};
